module.exports = __webpack_public_path__ + "img/MenuButton_QLD.667efeea.png";